import { render, staticRenderFns } from "./HowItWorks.vue?vue&type=template&id=4647fdbe&scoped=true&"
import script from "./HowItWorks.vue?vue&type=script&lang=js&"
export * from "./HowItWorks.vue?vue&type=script&lang=js&"
import style0 from "./HowItWorks.vue?vue&type=style&index=0&id=4647fdbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4647fdbe",
  null
  
)

export default component.exports